/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { bookingControllerAddAdvanceForGmg } from '../fn/booking/booking-controller-add-advance-for-gmg';
import { BookingControllerAddAdvanceForGmg$Params } from '../fn/booking/booking-controller-add-advance-for-gmg';
import { bookingControllerAddPayoutAccountAttachment } from '../fn/booking/booking-controller-add-payout-account-attachment';
import { BookingControllerAddPayoutAccountAttachment$Params } from '../fn/booking/booking-controller-add-payout-account-attachment';
import { bookingControllerAvailability } from '../fn/booking/booking-controller-availability';
import { BookingControllerAvailability$Params } from '../fn/booking/booking-controller-availability';
import { bookingControllerCount } from '../fn/booking/booking-controller-count';
import { BookingControllerCount$Params } from '../fn/booking/booking-controller-count';
import { bookingControllerCreate } from '../fn/booking/booking-controller-create';
import { BookingControllerCreate$Params } from '../fn/booking/booking-controller-create';
import { bookingControllerCreateForGmg } from '../fn/booking/booking-controller-create-for-gmg';
import { BookingControllerCreateForGmg$Params } from '../fn/booking/booking-controller-create-for-gmg';
import { bookingControllerCreatePayoutAccount } from '../fn/booking/booking-controller-create-payout-account';
import { BookingControllerCreatePayoutAccount$Params } from '../fn/booking/booking-controller-create-payout-account';
import { bookingControllerCreateStripePayment } from '../fn/booking/booking-controller-create-stripe-payment';
import { BookingControllerCreateStripePayment$Params } from '../fn/booking/booking-controller-create-stripe-payment';
import { bookingControllerCreateWalletTransfer } from '../fn/booking/booking-controller-create-wallet-transfer';
import { BookingControllerCreateWalletTransfer$Params } from '../fn/booking/booking-controller-create-wallet-transfer';
import { bookingControllerDeleteBooking } from '../fn/booking/booking-controller-delete-booking';
import { BookingControllerDeleteBooking$Params } from '../fn/booking/booking-controller-delete-booking';
import { bookingControllerDeletePayoutAccount } from '../fn/booking/booking-controller-delete-payout-account';
import { BookingControllerDeletePayoutAccount$Params } from '../fn/booking/booking-controller-delete-payout-account';
import { bookingControllerDownloadFinancialReport } from '../fn/booking/booking-controller-download-financial-report';
import { BookingControllerDownloadFinancialReport$Params } from '../fn/booking/booking-controller-download-financial-report';
import { bookingControllerDownloadRoomingList } from '../fn/booking/booking-controller-download-rooming-list';
import { BookingControllerDownloadRoomingList$Params } from '../fn/booking/booking-controller-download-rooming-list';
import { bookingControllerEarnedDonations } from '../fn/booking/booking-controller-earned-donations';
import { BookingControllerEarnedDonations$Params } from '../fn/booking/booking-controller-earned-donations';
import { bookingControllerEarnedPayments } from '../fn/booking/booking-controller-earned-payments';
import { BookingControllerEarnedPayments$Params } from '../fn/booking/booking-controller-earned-payments';
import { bookingControllerGenerateRefund } from '../fn/booking/booking-controller-generate-refund';
import { BookingControllerGenerateRefund$Params } from '../fn/booking/booking-controller-generate-refund';
import { bookingControllerGetAll } from '../fn/booking/booking-controller-get-all';
import { BookingControllerGetAll$Params } from '../fn/booking/booking-controller-get-all';
import { bookingControllerGetBooking } from '../fn/booking/booking-controller-get-booking';
import { BookingControllerGetBooking$Params } from '../fn/booking/booking-controller-get-booking';
import { bookingControllerGetPayoutAccounts } from '../fn/booking/booking-controller-get-payout-accounts';
import { BookingControllerGetPayoutAccounts$Params } from '../fn/booking/booking-controller-get-payout-accounts';
import { bookingControllerGetPayoutAccountsAll } from '../fn/booking/booking-controller-get-payout-accounts-all';
import { BookingControllerGetPayoutAccountsAll$Params } from '../fn/booking/booking-controller-get-payout-accounts-all';
import { bookingControllerGetRefunds } from '../fn/booking/booking-controller-get-refunds';
import { BookingControllerGetRefunds$Params } from '../fn/booking/booking-controller-get-refunds';
import { bookingControllerGetTotalOfDonations } from '../fn/booking/booking-controller-get-total-of-donations';
import { BookingControllerGetTotalOfDonations$Params } from '../fn/booking/booking-controller-get-total-of-donations';
import { bookingControllerGetWalletBalance } from '../fn/booking/booking-controller-get-wallet-balance';
import { BookingControllerGetWalletBalance$Params } from '../fn/booking/booking-controller-get-wallet-balance';
import { bookingControllerGetWalletBalanceGmg } from '../fn/booking/booking-controller-get-wallet-balance-gmg';
import { BookingControllerGetWalletBalanceGmg$Params } from '../fn/booking/booking-controller-get-wallet-balance-gmg';
import { bookingControllerGetWalletEarnedPaymentsByMethod } from '../fn/booking/booking-controller-get-wallet-earned-payments-by-method';
import { BookingControllerGetWalletEarnedPaymentsByMethod$Params } from '../fn/booking/booking-controller-get-wallet-earned-payments-by-method';
import { bookingControllerGetWalletTransfers } from '../fn/booking/booking-controller-get-wallet-transfers';
import { BookingControllerGetWalletTransfers$Params } from '../fn/booking/booking-controller-get-wallet-transfers';
import { bookingControllerGetWalletTransfersAll } from '../fn/booking/booking-controller-get-wallet-transfers-all';
import { BookingControllerGetWalletTransfersAll$Params } from '../fn/booking/booking-controller-get-wallet-transfers-all';
import { bookingControllerMyBookings } from '../fn/booking/booking-controller-my-bookings';
import { BookingControllerMyBookings$Params } from '../fn/booking/booking-controller-my-bookings';
import { bookingControllerPayoutAccountSetStatus } from '../fn/booking/booking-controller-payout-account-set-status';
import { BookingControllerPayoutAccountSetStatus$Params } from '../fn/booking/booking-controller-payout-account-set-status';
import { bookingControllerTravelBookings } from '../fn/booking/booking-controller-travel-bookings';
import { BookingControllerTravelBookings$Params } from '../fn/booking/booking-controller-travel-bookings';
import { bookingControllerTravelTravelers } from '../fn/booking/booking-controller-travel-travelers';
import { BookingControllerTravelTravelers$Params } from '../fn/booking/booking-controller-travel-travelers';
import { bookingControllerUpdateBankTransferPayment } from '../fn/booking/booking-controller-update-bank-transfer-payment';
import { BookingControllerUpdateBankTransferPayment$Params } from '../fn/booking/booking-controller-update-bank-transfer-payment';
import { bookingControllerUpdateDonationPayment } from '../fn/booking/booking-controller-update-donation-payment';
import { BookingControllerUpdateDonationPayment$Params } from '../fn/booking/booking-controller-update-donation-payment';
import { bookingControllerUpdatePayoutAccount } from '../fn/booking/booking-controller-update-payout-account';
import { BookingControllerUpdatePayoutAccount$Params } from '../fn/booking/booking-controller-update-payout-account';
import { bookingControllerUpdateRefundStatus } from '../fn/booking/booking-controller-update-refund-status';
import { BookingControllerUpdateRefundStatus$Params } from '../fn/booking/booking-controller-update-refund-status';
import { bookingControllerUserBookings } from '../fn/booking/booking-controller-user-bookings';
import { BookingControllerUserBookings$Params } from '../fn/booking/booking-controller-user-bookings';
import { bookingControllerUserPastBookings } from '../fn/booking/booking-controller-user-past-bookings';
import { BookingControllerUserPastBookings$Params } from '../fn/booking/booking-controller-user-past-bookings';
import { bookingControllerWalletTransferSetStatus } from '../fn/booking/booking-controller-wallet-transfer-set-status';
import { BookingControllerWalletTransferSetStatus$Params } from '../fn/booking/booking-controller-wallet-transfer-set-status';
import { BookingItem } from '../models/booking-item';
import { BookingsCountResponse } from '../models/bookings-count-response';
import { BookingsListResponse } from '../models/bookings-list-response';
import { DonationsListResponse } from '../models/donations-list-response';
import { EarnedPaymentsStatsByMethodResponse } from '../models/earned-payments-stats-by-method-response';
import { PaymentListResponse } from '../models/payment-list-response';
import { PayoutAccountItem } from '../models/payout-account-item';
import { PayoutAccountsResponse } from '../models/payout-accounts-response';
import { PayoutAccountsWithOwnersResponse } from '../models/payout-accounts-with-owners-response';
import { TravelBookingAvailability } from '../models/travel-booking-availability';
import { TravelBookingCreateResponseRedirect } from '../models/travel-booking-create-response-redirect';
import { TravelBookingsListResponse } from '../models/travel-bookings-list-response';
import { TravelBookingTravelersListResponse } from '../models/travel-booking-travelers-list-response';
import { UserBookingsListResponse } from '../models/user-bookings-list-response';
import { UserPastBookingsListResponse } from '../models/user-past-bookings-list-response';
import { WalletBalanceResponse } from '../models/wallet-balance-response';
import { WalletTotalOfDonations } from '../models/wallet-total-of-donations';
import { WalletTransferItem } from '../models/wallet-transfer-item';
import { WalletTransfersAllResponse } from '../models/wallet-transfers-all-response';
import { WalletTransfersResponse } from '../models/wallet-transfers-response';

@Injectable({ providedIn: 'root' })
export class BookingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `bookingControllerGetAll()` */
  static readonly BookingControllerGetAllPath = '/booking';

  /**
   * Restituisce tutti i booking (admin only).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetAll$Response(params: BookingControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BookingsListResponse;
}>> {
    return bookingControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce tutti i booking (admin only).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetAll(params: BookingControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BookingsListResponse;
}> {
    return this.bookingControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BookingsListResponse;
}>): BaseResponse & {
'data'?: BookingsListResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerMyBookings()` */
  static readonly BookingControllerMyBookingsPath = '/booking/my';

  /**
   * Restituisce i propri booking.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerMyBookings()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerMyBookings$Response(params: BookingControllerMyBookings$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BookingsListResponse;
}>> {
    return bookingControllerMyBookings(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i propri booking.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerMyBookings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerMyBookings(params: BookingControllerMyBookings$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BookingsListResponse;
}> {
    return this.bookingControllerMyBookings$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BookingsListResponse;
}>): BaseResponse & {
'data'?: BookingsListResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerCount()` */
  static readonly BookingControllerCountPath = '/booking/count';

  /**
   * Restituisce il count di tutti i booking.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerCount$Response(params?: BookingControllerCount$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BookingsCountResponse;
}>> {
    return bookingControllerCount(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce il count di tutti i booking.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerCount(params?: BookingControllerCount$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BookingsCountResponse;
}> {
    return this.bookingControllerCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BookingsCountResponse;
}>): BaseResponse & {
'data'?: BookingsCountResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerUserBookings()` */
  static readonly BookingControllerUserBookingsPath = '/booking/user/{user_id}';

  /**
   * Restituisce i booking di un utente (admin).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerUserBookings()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerUserBookings$Response(params: BookingControllerUserBookings$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserBookingsListResponse;
}>> {
    return bookingControllerUserBookings(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i booking di un utente (admin).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerUserBookings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerUserBookings(params: BookingControllerUserBookings$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserBookingsListResponse;
}> {
    return this.bookingControllerUserBookings$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserBookingsListResponse;
}>): BaseResponse & {
'data'?: UserBookingsListResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerUserPastBookings()` */
  static readonly BookingControllerUserPastBookingsPath = '/booking/user/{user_id}/past-travels';

  /**
   * Restituisce gli ultimi 5 viaggi a cui l'utente ha partecipato (booking status: payed).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerUserPastBookings()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerUserPastBookings$Response(params: BookingControllerUserPastBookings$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserPastBookingsListResponse;
}>> {
    return bookingControllerUserPastBookings(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce gli ultimi 5 viaggi a cui l'utente ha partecipato (booking status: payed).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerUserPastBookings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerUserPastBookings(params: BookingControllerUserPastBookings$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserPastBookingsListResponse;
}> {
    return this.bookingControllerUserPastBookings$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserPastBookingsListResponse;
}>): BaseResponse & {
'data'?: UserPastBookingsListResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerTravelBookings()` */
  static readonly BookingControllerTravelBookingsPath = '/booking/travel/{travel_id}';

  /**
   * Restituisce i booking di un travel (admin or tour leader) - Page "gestione viaggio".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerTravelBookings()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerTravelBookings$Response(params: BookingControllerTravelBookings$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingsListResponse;
}>> {
    return bookingControllerTravelBookings(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i booking di un travel (admin or tour leader) - Page "gestione viaggio".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerTravelBookings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerTravelBookings(params: BookingControllerTravelBookings$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelBookingsListResponse;
}> {
    return this.bookingControllerTravelBookings$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingsListResponse;
}>): BaseResponse & {
'data'?: TravelBookingsListResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerDownloadFinancialReport()` */
  static readonly BookingControllerDownloadFinancialReportPath = '/booking/travel/{travel_id}/xls-financial';

  /**
   * Scarica il report finanziario in formato XLSX.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerDownloadFinancialReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerDownloadFinancialReport$Response(params: BookingControllerDownloadFinancialReport$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return bookingControllerDownloadFinancialReport(this.http, this.rootUrl, params, context);
  }

  /**
   * Scarica il report finanziario in formato XLSX.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerDownloadFinancialReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerDownloadFinancialReport(params: BookingControllerDownloadFinancialReport$Params, context?: HttpContext): Observable<Blob> {
    return this.bookingControllerDownloadFinancialReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `bookingControllerDownloadRoomingList()` */
  static readonly BookingControllerDownloadRoomingListPath = '/booking/travel/{travel_id}/rooming-list';

  /**
   * Scarica il report delle stanze in formato XLSX.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerDownloadRoomingList()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerDownloadRoomingList$Response(params: BookingControllerDownloadRoomingList$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return bookingControllerDownloadRoomingList(this.http, this.rootUrl, params, context);
  }

  /**
   * Scarica il report delle stanze in formato XLSX.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerDownloadRoomingList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerDownloadRoomingList(params: BookingControllerDownloadRoomingList$Params, context?: HttpContext): Observable<Blob> {
    return this.bookingControllerDownloadRoomingList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `bookingControllerTravelTravelers()` */
  static readonly BookingControllerTravelTravelersPath = '/booking/travel/{travel_id}/travelers';

  /**
   * Restituisce i travelers di un travel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerTravelTravelers()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerTravelTravelers$Response(params: BookingControllerTravelTravelers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingTravelersListResponse;
}>> {
    return bookingControllerTravelTravelers(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i travelers di un travel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerTravelTravelers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerTravelTravelers(params: BookingControllerTravelTravelers$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelBookingTravelersListResponse;
}> {
    return this.bookingControllerTravelTravelers$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingTravelersListResponse;
}>): BaseResponse & {
'data'?: TravelBookingTravelersListResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerGetBooking()` */
  static readonly BookingControllerGetBookingPath = '/booking/{booking_identifier}';

  /**
   * Restituisce i dettagli di un booking.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerGetBooking()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetBooking$Response(params: BookingControllerGetBooking$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BookingItem;
}>> {
    return bookingControllerGetBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i dettagli di un booking.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerGetBooking$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetBooking(params: BookingControllerGetBooking$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BookingItem;
}> {
    return this.bookingControllerGetBooking$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BookingItem;
}>): BaseResponse & {
'data'?: BookingItem;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerDeleteBooking()` */
  static readonly BookingControllerDeleteBookingPath = '/booking/{booking_identifier}';

  /**
   * Elimina un booking.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerDeleteBooking()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerDeleteBooking$Response(params: BookingControllerDeleteBooking$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BookingItem;
}>> {
    return bookingControllerDeleteBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un booking.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerDeleteBooking$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerDeleteBooking(params: BookingControllerDeleteBooking$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BookingItem;
}> {
    return this.bookingControllerDeleteBooking$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BookingItem;
}>): BaseResponse & {
'data'?: BookingItem;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerAddAdvanceForGmg()` */
  static readonly BookingControllerAddAdvanceForGmgPath = '/booking/{booking_identifier}/add-advance';

  /**
   * Aggiunge un pagamento di anticipo a un booking (solo GMG).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerAddAdvanceForGmg()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerAddAdvanceForGmg$Response(params: BookingControllerAddAdvanceForGmg$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}>> {
    return bookingControllerAddAdvanceForGmg(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiunge un pagamento di anticipo a un booking (solo GMG).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerAddAdvanceForGmg$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerAddAdvanceForGmg(params: BookingControllerAddAdvanceForGmg$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}> {
    return this.bookingControllerAddAdvanceForGmg$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}>): BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerGenerateRefund()` */
  static readonly BookingControllerGenerateRefundPath = '/booking/{booking_identifier}/generate-refund';

  /**
   * Genera un rimborso per un booking (solo GMG).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerGenerateRefund()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGenerateRefund$Response(params: BookingControllerGenerateRefund$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BookingItem;
}>> {
    return bookingControllerGenerateRefund(this.http, this.rootUrl, params, context);
  }

  /**
   * Genera un rimborso per un booking (solo GMG).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerGenerateRefund$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGenerateRefund(params: BookingControllerGenerateRefund$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BookingItem;
}> {
    return this.bookingControllerGenerateRefund$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BookingItem;
}>): BaseResponse & {
'data'?: BookingItem;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerCreateStripePayment()` */
  static readonly BookingControllerCreateStripePaymentPath = '/booking/pay/{payment_identifier}';

  /**
   * Crea una sessione di pagamento Stripe (saldo).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerCreateStripePayment()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerCreateStripePayment$Response(params: BookingControllerCreateStripePayment$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}>> {
    return bookingControllerCreateStripePayment(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una sessione di pagamento Stripe (saldo).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerCreateStripePayment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerCreateStripePayment(params: BookingControllerCreateStripePayment$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}> {
    return this.bookingControllerCreateStripePayment$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}>): BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerGetRefunds()` */
  static readonly BookingControllerGetRefundsPath = '/booking/payment/refunds';

  /**
   * Restituisce i pagamenti di rimborso.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerGetRefunds()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetRefunds$Response(params: BookingControllerGetRefunds$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PaymentListResponse;
}>> {
    return bookingControllerGetRefunds(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i pagamenti di rimborso.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerGetRefunds$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetRefunds(params: BookingControllerGetRefunds$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: PaymentListResponse;
}> {
    return this.bookingControllerGetRefunds$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: PaymentListResponse;
}>): BaseResponse & {
'data'?: PaymentListResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerUpdateRefundStatus()` */
  static readonly BookingControllerUpdateRefundStatusPath = '/booking/payment/refunds/{payment_identifier}';

  /**
   * Aggiorna lo stato di un rimborso.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerUpdateRefundStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerUpdateRefundStatus$Response(params: BookingControllerUpdateRefundStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return bookingControllerUpdateRefundStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiorna lo stato di un rimborso.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerUpdateRefundStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerUpdateRefundStatus(params: BookingControllerUpdateRefundStatus$Params, context?: HttpContext): Observable<void> {
    return this.bookingControllerUpdateRefundStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `bookingControllerUpdateBankTransferPayment()` */
  static readonly BookingControllerUpdateBankTransferPaymentPath = '/booking/payment/{payment_identifier}';

  /**
   * Aggiorna lo stato di un pagamento (solo bonifico).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerUpdateBankTransferPayment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerUpdateBankTransferPayment$Response(params: BookingControllerUpdateBankTransferPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return bookingControllerUpdateBankTransferPayment(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiorna lo stato di un pagamento (solo bonifico).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerUpdateBankTransferPayment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerUpdateBankTransferPayment(params: BookingControllerUpdateBankTransferPayment$Params, context?: HttpContext): Observable<void> {
    return this.bookingControllerUpdateBankTransferPayment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `bookingControllerUpdateDonationPayment()` */
  static readonly BookingControllerUpdateDonationPaymentPath = '/booking/donation/{payment_identifier}';

  /**
   * Aggiorna lo stato di una donazione.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerUpdateDonationPayment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerUpdateDonationPayment$Response(params: BookingControllerUpdateDonationPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return bookingControllerUpdateDonationPayment(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiorna lo stato di una donazione.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerUpdateDonationPayment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerUpdateDonationPayment(params: BookingControllerUpdateDonationPayment$Params, context?: HttpContext): Observable<void> {
    return this.bookingControllerUpdateDonationPayment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `bookingControllerGetWalletBalance()` */
  static readonly BookingControllerGetWalletBalancePath = '/booking/wallet/balance';

  /**
   * Restituisce il saldo del proprio wallet.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerGetWalletBalance()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetWalletBalance$Response(params?: BookingControllerGetWalletBalance$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WalletBalanceResponse;
}>> {
    return bookingControllerGetWalletBalance(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce il saldo del proprio wallet.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerGetWalletBalance$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetWalletBalance(params?: BookingControllerGetWalletBalance$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WalletBalanceResponse;
}> {
    return this.bookingControllerGetWalletBalance$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WalletBalanceResponse;
}>): BaseResponse & {
'data'?: WalletBalanceResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerGetWalletBalanceGmg()` */
  static readonly BookingControllerGetWalletBalanceGmgPath = '/booking/wallet/balance-gmg';

  /**
   * Restituisce il saldo del proprio wallet GMG.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerGetWalletBalanceGmg()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetWalletBalanceGmg$Response(params?: BookingControllerGetWalletBalanceGmg$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WalletBalanceResponse;
}>> {
    return bookingControllerGetWalletBalanceGmg(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce il saldo del proprio wallet GMG.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerGetWalletBalanceGmg$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetWalletBalanceGmg(params?: BookingControllerGetWalletBalanceGmg$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WalletBalanceResponse;
}> {
    return this.bookingControllerGetWalletBalanceGmg$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WalletBalanceResponse;
}>): BaseResponse & {
'data'?: WalletBalanceResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerGetTotalOfDonations()` */
  static readonly BookingControllerGetTotalOfDonationsPath = '/booking/wallet/total-donations';

  /**
   * Restituisce il totale delle donazioni ricevute per GMG.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerGetTotalOfDonations()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetTotalOfDonations$Response(params?: BookingControllerGetTotalOfDonations$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WalletTotalOfDonations;
}>> {
    return bookingControllerGetTotalOfDonations(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce il totale delle donazioni ricevute per GMG.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerGetTotalOfDonations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetTotalOfDonations(params?: BookingControllerGetTotalOfDonations$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WalletTotalOfDonations;
}> {
    return this.bookingControllerGetTotalOfDonations$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WalletTotalOfDonations;
}>): BaseResponse & {
'data'?: WalletTotalOfDonations;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerEarnedPayments()` */
  static readonly BookingControllerEarnedPaymentsPath = '/booking/wallet/earned_payments';

  /**
   * Restituisce i pagamenti ricevuti e saldati di un tl pro.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerEarnedPayments()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerEarnedPayments$Response(params: BookingControllerEarnedPayments$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PaymentListResponse;
}>> {
    return bookingControllerEarnedPayments(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i pagamenti ricevuti e saldati di un tl pro.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerEarnedPayments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerEarnedPayments(params: BookingControllerEarnedPayments$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: PaymentListResponse;
}> {
    return this.bookingControllerEarnedPayments$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: PaymentListResponse;
}>): BaseResponse & {
'data'?: PaymentListResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerEarnedDonations()` */
  static readonly BookingControllerEarnedDonationsPath = '/booking/wallet/earned_donations';

  /**
   * Restituisce le donazioni ricevute di un tl pro.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerEarnedDonations()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerEarnedDonations$Response(params: BookingControllerEarnedDonations$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DonationsListResponse;
}>> {
    return bookingControllerEarnedDonations(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce le donazioni ricevute di un tl pro.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerEarnedDonations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerEarnedDonations(params: BookingControllerEarnedDonations$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DonationsListResponse;
}> {
    return this.bookingControllerEarnedDonations$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DonationsListResponse;
}>): BaseResponse & {
'data'?: DonationsListResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerGetWalletEarnedPaymentsByMethod()` */
  static readonly BookingControllerGetWalletEarnedPaymentsByMethodPath = '/booking/wallet/earned_payments/stats-by-method';

  /**
   * Restituisce i pagamenti ricevuti e saldati di un tl pro.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerGetWalletEarnedPaymentsByMethod()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetWalletEarnedPaymentsByMethod$Response(params?: BookingControllerGetWalletEarnedPaymentsByMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EarnedPaymentsStatsByMethodResponse;
}>> {
    return bookingControllerGetWalletEarnedPaymentsByMethod(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i pagamenti ricevuti e saldati di un tl pro.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerGetWalletEarnedPaymentsByMethod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetWalletEarnedPaymentsByMethod(params?: BookingControllerGetWalletEarnedPaymentsByMethod$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EarnedPaymentsStatsByMethodResponse;
}> {
    return this.bookingControllerGetWalletEarnedPaymentsByMethod$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EarnedPaymentsStatsByMethodResponse;
}>): BaseResponse & {
'data'?: EarnedPaymentsStatsByMethodResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerGetPayoutAccounts()` */
  static readonly BookingControllerGetPayoutAccountsPath = '/booking/wallet/payout_accounts';

  /**
   * Restituisce i conti bancari dell'utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerGetPayoutAccounts()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetPayoutAccounts$Response(params?: BookingControllerGetPayoutAccounts$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PayoutAccountsResponse;
}>> {
    return bookingControllerGetPayoutAccounts(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i conti bancari dell'utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerGetPayoutAccounts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetPayoutAccounts(params?: BookingControllerGetPayoutAccounts$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: PayoutAccountsResponse;
}> {
    return this.bookingControllerGetPayoutAccounts$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: PayoutAccountsResponse;
}>): BaseResponse & {
'data'?: PayoutAccountsResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerCreatePayoutAccount()` */
  static readonly BookingControllerCreatePayoutAccountPath = '/booking/wallet/payout_accounts';

  /**
   * Crea un conto bancario per l'utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerCreatePayoutAccount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerCreatePayoutAccount$Response(params: BookingControllerCreatePayoutAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PayoutAccountItem;
}>> {
    return bookingControllerCreatePayoutAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un conto bancario per l'utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerCreatePayoutAccount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerCreatePayoutAccount(params: BookingControllerCreatePayoutAccount$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: PayoutAccountItem;
}> {
    return this.bookingControllerCreatePayoutAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: PayoutAccountItem;
}>): BaseResponse & {
'data'?: PayoutAccountItem;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerGetPayoutAccountsAll()` */
  static readonly BookingControllerGetPayoutAccountsAllPath = '/booking/wallet/payout_accounts/all';

  /**
   * Restituisce tutti conti bancari dei tour leader.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerGetPayoutAccountsAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetPayoutAccountsAll$Response(params: BookingControllerGetPayoutAccountsAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PayoutAccountsWithOwnersResponse;
}>> {
    return bookingControllerGetPayoutAccountsAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce tutti conti bancari dei tour leader.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerGetPayoutAccountsAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetPayoutAccountsAll(params: BookingControllerGetPayoutAccountsAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: PayoutAccountsWithOwnersResponse;
}> {
    return this.bookingControllerGetPayoutAccountsAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: PayoutAccountsWithOwnersResponse;
}>): BaseResponse & {
'data'?: PayoutAccountsWithOwnersResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerAddPayoutAccountAttachment()` */
  static readonly BookingControllerAddPayoutAccountAttachmentPath = '/booking/wallet/payout_accounts/{id}';

  /**
   * Aggiunge un allegato al payout account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerAddPayoutAccountAttachment()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  bookingControllerAddPayoutAccountAttachment$Response(params: BookingControllerAddPayoutAccountAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return bookingControllerAddPayoutAccountAttachment(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiunge un allegato al payout account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerAddPayoutAccountAttachment$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  bookingControllerAddPayoutAccountAttachment(params: BookingControllerAddPayoutAccountAttachment$Params, context?: HttpContext): Observable<void> {
    return this.bookingControllerAddPayoutAccountAttachment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `bookingControllerDeletePayoutAccount()` */
  static readonly BookingControllerDeletePayoutAccountPath = '/booking/wallet/payout_accounts/{id}';

  /**
   * Elimina un conto bancario dell'utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerDeletePayoutAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerDeletePayoutAccount$Response(params: BookingControllerDeletePayoutAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PayoutAccountItem;
}>> {
    return bookingControllerDeletePayoutAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un conto bancario dell'utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerDeletePayoutAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerDeletePayoutAccount(params: BookingControllerDeletePayoutAccount$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: PayoutAccountItem;
}> {
    return this.bookingControllerDeletePayoutAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: PayoutAccountItem;
}>): BaseResponse & {
'data'?: PayoutAccountItem;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerUpdatePayoutAccount()` */
  static readonly BookingControllerUpdatePayoutAccountPath = '/booking/wallet/payout_accounts/{id}';

  /**
   * Aggiorna i dati di un conto bancario.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerUpdatePayoutAccount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerUpdatePayoutAccount$Response(params: BookingControllerUpdatePayoutAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PayoutAccountItem;
}>> {
    return bookingControllerUpdatePayoutAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiorna i dati di un conto bancario.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerUpdatePayoutAccount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerUpdatePayoutAccount(params: BookingControllerUpdatePayoutAccount$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: PayoutAccountItem;
}> {
    return this.bookingControllerUpdatePayoutAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: PayoutAccountItem;
}>): BaseResponse & {
'data'?: PayoutAccountItem;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerPayoutAccountSetStatus()` */
  static readonly BookingControllerPayoutAccountSetStatusPath = '/booking/wallet/payout_accounts/{id}/status';

  /**
   * Cambia lo stato di un payout account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerPayoutAccountSetStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerPayoutAccountSetStatus$Response(params: BookingControllerPayoutAccountSetStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return bookingControllerPayoutAccountSetStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Cambia lo stato di un payout account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerPayoutAccountSetStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerPayoutAccountSetStatus(params: BookingControllerPayoutAccountSetStatus$Params, context?: HttpContext): Observable<void> {
    return this.bookingControllerPayoutAccountSetStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `bookingControllerGetWalletTransfers()` */
  static readonly BookingControllerGetWalletTransfersPath = '/booking/wallet/transfer';

  /**
   * Restituisce tutti i trasferimenti dell'utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerGetWalletTransfers()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetWalletTransfers$Response(params: BookingControllerGetWalletTransfers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WalletTransfersResponse;
}>> {
    return bookingControllerGetWalletTransfers(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce tutti i trasferimenti dell'utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerGetWalletTransfers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetWalletTransfers(params: BookingControllerGetWalletTransfers$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WalletTransfersResponse;
}> {
    return this.bookingControllerGetWalletTransfers$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WalletTransfersResponse;
}>): BaseResponse & {
'data'?: WalletTransfersResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerCreateWalletTransfer()` */
  static readonly BookingControllerCreateWalletTransferPath = '/booking/wallet/transfer';

  /**
   * Crea un trasferimento di denario dal wallet dell'utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerCreateWalletTransfer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerCreateWalletTransfer$Response(params: BookingControllerCreateWalletTransfer$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WalletTransferItem;
}>> {
    return bookingControllerCreateWalletTransfer(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un trasferimento di denario dal wallet dell'utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerCreateWalletTransfer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerCreateWalletTransfer(params: BookingControllerCreateWalletTransfer$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WalletTransferItem;
}> {
    return this.bookingControllerCreateWalletTransfer$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WalletTransferItem;
}>): BaseResponse & {
'data'?: WalletTransferItem;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerGetWalletTransfersAll()` */
  static readonly BookingControllerGetWalletTransfersAllPath = '/booking/wallet/transfer/all';

  /**
   * Restituisce tutti i trasferimenti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerGetWalletTransfersAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetWalletTransfersAll$Response(params: BookingControllerGetWalletTransfersAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WalletTransfersAllResponse;
}>> {
    return bookingControllerGetWalletTransfersAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce tutti i trasferimenti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerGetWalletTransfersAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerGetWalletTransfersAll(params: BookingControllerGetWalletTransfersAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WalletTransfersAllResponse;
}> {
    return this.bookingControllerGetWalletTransfersAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WalletTransfersAllResponse;
}>): BaseResponse & {
'data'?: WalletTransfersAllResponse;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerWalletTransferSetStatus()` */
  static readonly BookingControllerWalletTransferSetStatusPath = '/booking/wallet/transfer/{id}/status';

  /**
   * Cambia lo stato di un trasferimento wallet.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerWalletTransferSetStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerWalletTransferSetStatus$Response(params: BookingControllerWalletTransferSetStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WalletTransferItem;
}>> {
    return bookingControllerWalletTransferSetStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Cambia lo stato di un trasferimento wallet.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerWalletTransferSetStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerWalletTransferSetStatus(params: BookingControllerWalletTransferSetStatus$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WalletTransferItem;
}> {
    return this.bookingControllerWalletTransferSetStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WalletTransferItem;
}>): BaseResponse & {
'data'?: WalletTransferItem;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerCreate()` */
  static readonly BookingControllerCreatePath = '/booking/{travel_id}';

  /**
   * Crea un booking.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerCreate$Response(params: BookingControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}>> {
    return bookingControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un booking.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerCreate(params: BookingControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}> {
    return this.bookingControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}>): BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerCreateForGmg()` */
  static readonly BookingControllerCreateForGmgPath = '/booking/{travel_id}/gmg';

  /**
   * Crea un booking per GMG.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerCreateForGmg()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerCreateForGmg$Response(params: BookingControllerCreateForGmg$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}>> {
    return bookingControllerCreateForGmg(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un booking per GMG.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerCreateForGmg$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bookingControllerCreateForGmg(params: BookingControllerCreateForGmg$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}> {
    return this.bookingControllerCreateForGmg$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}>): BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
} => r.body)
    );
  }

  /** Path part for operation `bookingControllerAvailability()` */
  static readonly BookingControllerAvailabilityPath = '/booking/{travel_id}/availability';

  /**
   * Restituisce la disponibilità dei posti di un viaggio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bookingControllerAvailability()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerAvailability$Response(params: BookingControllerAvailability$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingAvailability;
}>> {
    return bookingControllerAvailability(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce la disponibilità dei posti di un viaggio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bookingControllerAvailability$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bookingControllerAvailability(params: BookingControllerAvailability$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TravelBookingAvailability;
}> {
    return this.bookingControllerAvailability$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingAvailability;
}>): BaseResponse & {
'data'?: TravelBookingAvailability;
} => r.body)
    );
  }

}
